import { setFontVariant } from "@similarweb/styles";
import { Button, ButtonLabel } from "@similarweb/ui-components";
import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";
import { PopupClickContainerStateless } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import type { FC, ReactNode } from "react";
import { useState } from "react";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";
import { NoPrintContainer } from "app/components/layout/NoPrintContainer";

const NOTIFICATION_WRAPPER_CLASS = "custom-industry-button-notification-wrapper";

const ContentWrapper = styled(FlexColumn)`
    padding: 16px;
    gap: 8px;
`;
const Title = styled.span`
    ${setFontVariant("listItem1")}
`;
const Body = styled.span`
    ${setFontVariant("tooltip")}
`;

const Footer = styled(FlexRow)`
    height: 36px;
    align-items: center;
    justify-content: flex-end;
`;

const CustomIndustryButtonNotificationContent: FC<{ onClose: VoidFunction }> = ({ onClose }) => {
    return (
        <ContentWrapper>
            <Title>{translate("querybar.websites.createCustomCategory.button.notification.title")}</Title>
            <Body>{translate("querybar.websites.createCustomCategory.button.notification.text")}</Body>
            <Footer>
                <Button
                    type={buttonTypes.INVERTED}
                    onClick={onClose}
                >
                    <ButtonLabel>{translate("modal.no-touch.not-allowed.button")}</ButtonLabel>
                </Button>
            </Footer>
        </ContentWrapper>
    );
};

interface ICustomIndustryButtonNotification {
    children: ReactNode;
    isVisible: boolean;
    onCloseNotificationClick: VoidFunction;
}

export const CustomIndustryButtonNotification: FC<ICustomIndustryButtonNotification> = ({
    children,
    isVisible = false,
    onCloseNotificationClick,
}) => {
    const [isOpen, setIsOpen] = useState(isVisible);

    const onClickClose = () => {
        onCloseNotificationClick();
        setIsOpen(false);
    };

    const popupConfig = {
        enabled: true,
        defaultOpen: true,
        placement: "bottom",
        cssClass: "Popup-element-wrapper--notification-mode",
        cssClassContent: "Popup-content-no-padding",
        width: 265,
    };
    return (
        <NoPrintContainer className={NOTIFICATION_WRAPPER_CLASS}>
            <PopupClickContainerStateless
                isOpen={isOpen}
                appendTo={`.${NOTIFICATION_WRAPPER_CLASS}`}
                content={() => <CustomIndustryButtonNotificationContent onClose={onClickClose} />}
                config={popupConfig}
            >
                <div>{children}</div>
            </PopupClickContainerStateless>
        </NoPrintContainer>
    );
};
